import { Button } from '@/shared/ui/button'
import { cn } from '@/utils/cn'
import Image from 'next/image'
import { HTMLAttributes } from 'react'
import { AuthSignedIn } from '@/components/auth/auth-signed-in'
import { AuthSignedOut } from '@/components/auth/auth-signed-out'
import { signIn } from 'next-auth/react'
import { useNotificationStore } from '@/providers/notification-store-provider'
export interface ProductNotificationInfoBeforeProps {
  productId: string
  price: number
  priceLowest: number
}
// TODO: 알림 설정 버튼 리팩토링
export const ProductNotificationInfoBefore = ({
  className,
  productId,
  price,
  priceLowest,
  ...props
}: ProductNotificationInfoBeforeProps & HTMLAttributes<HTMLDivElement>) => {
  const { onClickDrawer } = useNotificationStore((state) => state)
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4',
        className,
      )}
      {...props}
    >
      <Image src={'/icons/상품상세_벨.svg'} alt={''} width={30} height={30} />
      <div className="text-center text-body-01-semi">
        <p>알림을 설정하고 </p>
        <p>
          <span className="text-primary">구매타이밍</span>을 노려보세요!
        </p>
      </div>
      <AuthSignedOut>
        <Button
          onClick={() => signIn()}
          variant={'outline'}
          className="h-fit rounded-full px-3 py-2"
        >
          알림 설정하기
        </Button>
      </AuthSignedOut>
      <AuthSignedIn>
        <Button
          onClick={(e) => {
            e.preventDefault()
            onClickDrawer()({ productId, price, priceLowest })
          }}
        >
          알림 설정하기
        </Button>
      </AuthSignedIn>
    </div>
  )
}
